import apiClient from "./client";
import { POST_PROJECT } from "./enpoint";

export const sendRegistrationEmailOTP = async (data) => {
  try {
    const response = await apiClient.post("/auth/send-registration-email-otp", data);
    if (response?.data) {
      return { success: true, message: response.data.message };
    }
  } catch (error) {
    console.error("Send registration email OTP error", error);
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to send OTP",
    };
  }
};

export const verifyRegistrationEmailOTP = async (data) => {
  try {
    const response = await apiClient.post("/auth/verify-registration-email-otp", data);
    if (response?.data) {
      return { success: true, message: response.data.message };
    }
  } catch (error) {
    console.error("Verify registration email OTP error", error);
    return {
      success: false,
      message: error?.response?.data?.message || "Invalid OTP",
    };
  }
};

export const register = async (data) => {
  try {
    const response = await apiClient.post("/auth/register", data);
    if (response?.data) {
      return { success: true };
    }
  } catch (error) {
    console.error("Register error", error);
    return {
      success: false,
      message: error?.response?.data?.message || "Registration failed",
    };
  }
};

export const signIn = async (data) => {
  try {
    const response = await apiClient.post("/auth/login", data);
    if (response?.data?.token) {
      localStorage.setItem("token", response.data.token); // Store token for authentication
      return { success: true, user: response.data.user };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || error?.message || "Login failed",
      user: null,
    };
  }
};

export const validateSession = async () => {
  const response = await apiClient.post("/auth/me");
  return { success: true, user: response.data.user };
};

export const forgetPassword = async (data) => {
  try {
    const response = await apiClient.post("/auth/forget-password", data);
    if (response?.data) {
      return { success: true, message: response.data.message };
    }
  } catch (error) {
    console.error("Forget password error", error);
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to send reset email",
    };
  }
};

export const verifyOTP = async (data) => {
  try {
    const response = await apiClient.post("/auth/verify-email-otp", data);
    if (response?.data) {
      return {
        success: true,
        message: response.data.message,
        token: response.data.token,
      };
    }
  } catch (error) {
    console.error("OTP verification error", error);
    return {
      success: false,
      message: error?.response?.data?.message || "Invalid OTP",
    };
  }
};

export const resetPassword = async (data) => {
  try {
    const response = await apiClient.post("/auth/reset-password", data);
    if (response?.data) {
      return { success: true, message: response.data.message };
    }
  } catch (error) {
    console.error("Reset password error", error);
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to reset password",
    };
  }
};

export const verifyCurrentPassword = async (data) => {
  try {
    const response = await apiClient.post(
      "/auth/verify-current-password",
      data
    );
    if (response?.data) {
      return { success: true, message: response.data.message };
    }
  } catch (error) {
    console.error("Password verification error", error);
    return {
      success: false,
      message:
        error?.response?.data?.message || "Current password is incorrect",
    };
  }
};

export const changePassword = async (data) => {
  try {
    const response = await apiClient.post("/auth/change-password", data);
    if (response?.data) {
      return { success: true, message: response.data.message };
    }
  } catch (error) {
    console.error("Change password error", error);
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to change password",
    };
  }
};

export const uploadSingleFile = async (file) => {
  try {
    const { data } = await apiClient.post("/upload/single", file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return { success: true, ...data };
  } catch (error) {
    return { success: false, message: "Failed to upload" };
  }
};

export const updateProject = async (updatedData, projectId) => {
  const { data } = await apiClient.patch(`/projects/${projectId}`, updatedData);
  return data;
};

export const updatedProfile = async (updatedData, employeeId = null) => {
  // If employeeId is provided, add it to the data
  if (employeeId) {
    if (updatedData instanceof FormData) {
      updatedData.append("employeeId", employeeId);
    } else {
      updatedData = { ...updatedData, employeeId };
    }
  }

  const headers = {
    "Content-Type":
      updatedData instanceof FormData
        ? "multipart/form-data"
        : "application/json",
  };
  const { data } = await apiClient.patch("/employee/profile", updatedData, {
    headers,
  });
  return data;
};

export const createTask = async (taskData, projectId) => {
  console.log(taskData, "taskData");
  // api formated data
  const data = {
    title: taskData?.title,
    task_description: taskData?.task_description,
    description: taskData?.description,
    copyOfDescription: taskData?.copyOfDescription,
    project: `${projectId}`,
    attachments: taskData?.attachments,
    assignedTo: taskData?.assignedTo,
    priority: taskData?.priority,
    dueDate: taskData?.dueDate,
    startDate: taskData?.startDate,
    taskGroup: taskData?.taskGroup,
    extraTaskWorkType: taskData?.extraTaskWorkType,
    taskMonth: taskData?.taskMonth,
    timeEstimate: taskData?.timeEstimate,

    // taskFlow will be conditionally added below
    requiresClientApproval: taskData?.requiresClientApproval,
    sequentialSubtasks: taskData?.sequentialSubtasks,
    requiresWorkLink: taskData?.requiresWorkLink,
    campaign: taskData?.campaign || undefined,
    requiresCampaignReport: taskData?.requiresCampaignReport,
    customFields: taskData?.customFields,
    subtasks: taskData?.subtasks,
    taskCategory: taskData?.taskCategory || undefined,
    assetBankItem: taskData?.assetBankItem || undefined,
    coveredTasks:
      Array.isArray(taskData?.coveredTasks) && taskData.coveredTasks.length
        ? taskData.coveredTasks
        : undefined,
  };
  if (taskData?.taskFlow) {
    data.taskFlow = taskData.taskFlow; // Only add if present
  }
  const response = await apiClient.post("/tasks", data);
  return response;
};

export const createTaskFromBoard = async (taskData) => {
  // api formated data for board view
  const data = {
    title: taskData?.title,
    task_description: taskData?.task_description,
    description: taskData?.description,
    copyOfDescription: taskData?.copyOfDescription,
    attachments: taskData?.attachments,
    assignedTo: taskData?.assignedTo,
    priority: taskData?.priority,
    dueDate: taskData?.dueDate,
    startDate: taskData?.startDate,
    taskMonth: taskData?.taskMonth,
    timeEstimate: taskData?.timeEstimate,

    // Board-specific fields
    isBoardTask: true,
    sourceProject: taskData?.project || null,

    requiresClientApproval: taskData?.requiresClientApproval,
    sequentialSubtasks: taskData?.sequentialSubtasks,
    requiresWorkLink: taskData?.requiresWorkLink,
    campaign: taskData?.campaign || undefined,
    requiresCampaignReport: taskData?.requiresCampaignReport,
    customFields: taskData?.customFields,
    subtasks: taskData?.subtasks,
    taskCategory: taskData?.taskCategory || undefined,
  };

  // Handle project field based on selection
  if (
    taskData?.project &&
    taskData.project !== "other" &&
    taskData.project !== ""
  ) {
    data.project = taskData.project;
    // Add project-specific fields only if project is selected
    if (taskData?.taskGroup) {
      data.taskGroup = taskData.taskGroup;
    }
    if (taskData?.extraTaskWorkType) {
      data.extraTaskWorkType = taskData.extraTaskWorkType;
    }
    if (taskData?.taskFlow) {
      data.taskFlow = taskData.taskFlow;
    }
  } else {
    // For "Other" project or no project, set project to null
    data.project = null;
  }

  const response = await apiClient.post("/tasks", data);
  return response;
};

export const getTaskById = async (taskId) => {
  const { data } = await apiClient.get(`/tasks/${taskId}`);
  return data;
};

export const updateTaskById = async (taskId, updatedData) => {
  const { data } = await apiClient.put(`/tasks/${taskId}`, updatedData);
  return data;
};

export const moveTaskToProject = async (taskId, moveData) => {
  const { data } = await apiClient.put(`/tasks/${taskId}/move`, moveData);
  return data;
};

export const moveTaskToMonth = async (taskId, moveData) => {
  const { data } = await apiClient.put(`/tasks/${taskId}/move-month`, moveData);
  return data;
};

export const getTasksOnReview = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    // Add filters to query parameters
    if (filters.page) params.append("page", filters.page);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.search) params.append("search", filters.search);
    if (filters.priority) params.append("priority", filters.priority);
    if (filters.projectId) params.append("projectId", filters.projectId);
    if (filters.sortBy) params.append("sortBy", filters.sortBy);
    if (filters.sortOrder) params.append("sortOrder", filters.sortOrder);
    if (filters.taskMonth) params.append("taskMonth", filters.taskMonth);

    if (filters.reporterId) params.append("reporterId", filters.reporterId);

    const { data } = await apiClient.get(
      `/tasks/on-review?${params.toString()}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getTasksOnPublish = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    // Add filters to query parameters
    if (filters.page) params.append("page", filters.page);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.search) params.append("search", filters.search);
    if (filters.priority) params.append("priority", filters.priority);
    if (filters.projectId) params.append("projectId", filters.projectId);
    if (filters.sortBy) params.append("sortBy", filters.sortBy);
    if (filters.sortOrder) params.append("sortOrder", filters.sortOrder);
    if (filters.taskMonth) params.append("taskMonth", filters.taskMonth);

    const { data } = await apiClient.get(
      `/tasks/on-publish?${params.toString()}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getClientReviewTasks = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    // Add filters to query parameters
    if (filters.page) params.append("page", filters.page);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.search) params.append("search", filters.search);
    if (filters.priority) params.append("priority", filters.priority);
    if (filters.projectId) params.append("projectId", filters.projectId);
    if (filters.sortBy) params.append("sortBy", filters.sortBy);
    if (filters.sortOrder) params.append("sortOrder", filters.sortOrder);
    if (filters.taskMonth) params.append("taskMonth", filters.taskMonth);

    if (filters.reporterId) params.append("reporterId", filters.reporterId);

    const { data } = await apiClient.get(
      `/tasks/client-review?${params.toString()}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const markSentToClient = async (itemId, payload = {}) => {
  const { data } = await apiClient.post(
    `/tasks/${itemId}/sent-to-client`,
    payload
  );
  return data;
};

export const extendEmployeeProbation = async (employeeId, payload) => {
  const { data } = await apiClient.patch(
    `/employee/${employeeId}/probation/extend`,
    payload
  );
  return data;
};

export const closeEmployeeProbation = async (employeeId, payload) => {
  const { data } = await apiClient.patch(
    `/employee/${employeeId}/probation/end`,
    payload
  );
  return data;
};

export const updateEmployeeProbationDates = async (employeeId, payload) => {
  const { data } = await apiClient.patch(
    `/employee/${employeeId}/probation/dates`,
    payload
  );
  return data;
};

export const createEmployee = async (employeeData) => {
  const { data } = await apiClient.post("/employee", employeeData);
  return data;
};

////////////  PROJECT SERVICES ⚒️⚒️⚒️⚒️⚒️ ////////////////
export const addProject = (projectDetails) => {
  return apiClient.post(POST_PROJECT, projectDetails).then((res) => res.data);
};

export const updateTaskOrder = async (taskId, newOrder) => {
  return apiClient
    .put(`/tasks/${taskId}/order`, { newOrder })
    .then((res) => res.data);
};

export const deleteProject = async (projectId) => {
  const response = await apiClient.delete(`/projects/${projectId}`);
  return response.data;
};

export const pauseProject = async (projectId) => {
  const response = await apiClient.patch(`/projects/${projectId}/pause`);
  return response.data;
};

export const resumeProject = async (projectId) => {
  const response = await apiClient.patch(`/projects/${projectId}/resume`);
  return response.data;
};

export const updateDailyChecklistStatus = async (projectId, data) => {
  const response = await apiClient.patch(`/projects/${projectId}/daily-checklist/status`, data);
  return response.data;
};

// SubTask API functions
export const createSubTask = async (subTaskData) => {
  try {
    const response = await apiClient.post("/subtasks", subTaskData);
    return response.data;
  } catch (error) {
    console.error("Error creating subtask:", error);
    throw error;
  }
};

export const getSubTasksByParentTask = async (parentTaskId) => {
  try {
    const response = await apiClient.get(`/subtasks/parent/${parentTaskId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subtasks:", error);
    throw error;
  }
};

export const getSubTaskById = async (subTaskId) => {
  try {
    const response = await apiClient.get(`/subtasks/${subTaskId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subtask:", error);
    throw error;
  }
};

export const updateSubTaskById = async (subTaskId, updateData) => {
  try {
    const response = await apiClient.put(`/subtasks/${subTaskId}`, updateData);
    return response.data;
  } catch (error) {
    console.error("Error updating subtask:", error);
    throw error;
  }
};

export const createReworkEvent = async (taskId, payload) => {
  const response = await apiClient.post(`/tasks/${taskId}/rework`, payload);
  return response.data;
};

export const getReworkCandidates = async (taskId, { originSubTaskId, source } = {}) => {
  const response = await apiClient.get(`/tasks/${taskId}/rework-candidates`, {
    params: { originSubTaskId, source },
  });
  return response.data;
};

export const deleteSubTask = async (subTaskId) => {
  try {
    const response = await apiClient.delete(`/subtasks/${subTaskId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting subtask:", error);
    throw error;
  }
};

// SubTask Attachment API functions
export const addSubTaskAttachments = async (subTaskId, attachments) => {
  try {
    const response = await apiClient.post(
      `/subtasks/${subTaskId}/attachments`,
      { attachments },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding subtask attachments:", error);
    throw error;
  }
};

export const removeSubTaskAttachment = async (subTaskId, attachmentId) => {
  try {
    const response = await apiClient.delete(
      `/subtasks/${subTaskId}/attachments/${attachmentId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error removing subtask attachment:", error);
    throw error;
  }
};

// Notification API functions
export const getUserNotifications = async (limit = 10) => {
  try {
    const response = await apiClient.get(`/notifications?limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await apiClient.patch(
      `/notifications/${notificationId}/read`
    );
    return response.data;
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error;
  }
};

export const markAllNotificationsAsRead = async () => {
  try {
    const response = await apiClient.patch("/notifications/mark-all-read");
    return response.data;
  } catch (error) {
    console.error("Error marking all notifications as read:", error);
    throw error;
  }
};

export const getUnreadNotificationCount = async () => {
  try {
    const response = await apiClient.get("/notifications/unread-count");
    return response.data;
  } catch (error) {
    console.error("Error fetching unread notification count:", error);
    throw error;
  }
};

////////////  STICKY NOTES SERVICES ⚒️⚒️⚒️⚒️⚒️ ////////////////

// Create a new sticky note
export const createStickyNote = async (noteData) => {
  try {
    const response = await apiClient.post("/sticky-notes", noteData);
    return response.data;
  } catch (error) {
    console.error("Error creating sticky note:", error);
    throw error;
  }
};

// Get all user's sticky notes
export const getUserStickyNotes = async (options = {}) => {
  try {
    const params = new URLSearchParams();

    if (options.isArchived !== undefined)
      params.append("isArchived", options.isArchived);
    if (options.priority) params.append("priority", options.priority);
    if (options.sortBy) params.append("sortBy", options.sortBy);
    if (options.sortOrder) params.append("sortOrder", options.sortOrder);
    if (options.limit) params.append("limit", options.limit);
    if (options.skip) params.append("skip", options.skip);
    if (options.tags) {
      if (Array.isArray(options.tags)) {
        options.tags.forEach((tag) => params.append("tags", tag));
      } else {
        params.append("tags", options.tags);
      }
    }

    const response = await apiClient.get(`/sticky-notes?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching sticky notes:", error);
    throw error;
  }
};

// Get a specific sticky note by ID
export const getStickyNoteById = async (noteId) => {
  try {
    const response = await apiClient.get(`/sticky-notes/${noteId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching sticky note:", error);
    throw error;
  }
};

// Update a sticky note
export const updateStickyNote = async (noteId, updateData) => {
  try {
    const response = await apiClient.put(`/sticky-notes/${noteId}`, updateData);
    return response.data;
  } catch (error) {
    console.error("Error updating sticky note:", error);
    throw error;
  }
};

// Delete a sticky note
export const deleteStickyNote = async (noteId) => {
  try {
    const response = await apiClient.delete(`/sticky-notes/${noteId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting sticky note:", error);
    throw error;
  }
};

// Update sticky note positions (for drag and drop)
export const updateStickyNotePositions = async (noteIds) => {
  try {
    const response = await apiClient.put("/sticky-notes/positions", {
      noteIds,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating sticky note positions:", error);
    throw error;
  }
};

// Archive/Unarchive a sticky note
export const toggleArchiveStickyNote = async (noteId) => {
  try {
    const response = await apiClient.put(`/sticky-notes/${noteId}/archive`);
    return response.data;
  } catch (error) {
    console.error("Error toggling sticky note archive:", error);
    throw error;
  }
};

// Set reminder for a sticky note
export const setStickyNoteReminder = async (noteId, reminderDate) => {
  try {
    const response = await apiClient.put(`/sticky-notes/${noteId}/reminder`, {
      reminderDate,
    });
    return response.data;
  } catch (error) {
    console.error("Error setting sticky note reminder:", error);
    throw error;
  }
};

// Clear reminder for a sticky note
export const clearStickyNoteReminder = async (noteId) => {
  try {
    const response = await apiClient.delete(`/sticky-notes/${noteId}/reminder`);
    return response.data;
  } catch (error) {
    console.error("Error clearing sticky note reminder:", error);
    throw error;
  }
};

// Get archived sticky notes
export const getArchivedStickyNotes = async (options = {}) => {
  try {
    const params = new URLSearchParams();

    if (options.sortBy) params.append("sortBy", options.sortBy);
    if (options.sortOrder) params.append("sortOrder", options.sortOrder);
    if (options.limit) params.append("limit", options.limit);
    if (options.skip) params.append("skip", options.skip);

    const response = await apiClient.get(
      `/sticky-notes/archived?${params.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching archived sticky notes:", error);
    throw error;
  }
};

// Get sticky notes with active reminders
export const getStickyNotesWithReminders = async () => {
  try {
    const response = await apiClient.get("/sticky-notes/reminders");
    return response.data;
  } catch (error) {
    console.error("Error fetching sticky notes with reminders:", error);
    throw error;
  }
};

// Bulk delete sticky notes
export const bulkDeleteStickyNotes = async (noteIds) => {
  try {
    const response = await apiClient.delete("/sticky-notes/bulk", {
      data: { noteIds },
    });
    return response.data;
  } catch (error) {
    console.error("Error bulk deleting sticky notes:", error);
    throw error;
  }
};

////////////  ATTENDANCE SERVICES ⚒️⚒️⚒️⚒️⚒️ ////////////////

// Clock in - Start attendance
export const clockIn = async (attendanceData) => {
  try {
    const response = await apiClient.post(
      "/attendance/clock-in",
      attendanceData
    );
    return response.data;
  } catch (error) {
    console.error("Error clocking in:", error);
    throw error;
  }
};

// Clock out - End attendance
export const clockOut = async (clockOutData) => {
  try {
    const response = await apiClient.post(
      "/attendance/clock-out",
      clockOutData
    );
    return response.data;
  } catch (error) {
    console.error("Error clocking out:", error);
    throw error;
  }
};

// Start break
export const startBreak = async (breakData = {}) => {
  try {
    const response = await apiClient.post("/attendance/break/start", breakData);
    return response.data;
  } catch (error) {
    console.error("Error starting break:", error);
    throw error;
  }
};

// End break
export const endBreak = async () => {
  try {
    const response = await apiClient.post("/attendance/break/end");
    return response.data;
  } catch (error) {
    console.error("Error ending break:", error);
    throw error;
  }
};

// Get current attendance status
export const getCurrentAttendanceStatus = async () => {
  try {
    const response = await apiClient.get("/attendance/status");
    return response.data;
  } catch (error) {
    console.error("Error getting attendance status:", error);
    throw error;
  }
};

// Get employee attendance history
export const getEmployeeAttendanceHistory = async (
  employeeId,
  queryParams = {}
) => {
  try {
    const params = new URLSearchParams();

    // Add query parameters
    if (queryParams.page) params.append("page", queryParams.page);
    if (queryParams.limit) params.append("limit", queryParams.limit);
    if (queryParams.startDate)
      params.append("startDate", queryParams.startDate);
    if (queryParams.endDate) params.append("endDate", queryParams.endDate);

    const response = await apiClient.get(
      `/attendance/employee/${employeeId}?${params.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting attendance history:", error);
    throw error;
  }
};

// Get daily attendance report (Admin only)
export const getDailyAttendanceReport = async (date = null) => {
  try {
    const params = new URLSearchParams();
    if (date) params.append("date", date);

    const response = await apiClient.get(
      `/attendance/daily-report?${params.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting daily report:", error);
    throw error;
  }
};

// Get attendance summary (Admin only)
export const getAttendanceSummary = async (queryParams) => {
  try {
    const params = new URLSearchParams();

    if (queryParams.startDate)
      params.append("startDate", queryParams.startDate);
    if (queryParams.endDate) params.append("endDate", queryParams.endDate);
    if (queryParams.employeeId)
      params.append("employeeId", queryParams.employeeId);

    const response = await apiClient.get(
      `/attendance/summary?${params.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting attendance summary:", error);
    throw error;
  }
};

// Get attendance analytics (Admin only)
export const getAttendanceAnalytics = async (period = "month") => {
  try {
    const response = await apiClient.get(
      `/attendance/analytics?period=${period}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting attendance analytics:", error);
    throw error;
  }
};

// Update attendance record (Admin only)
export const updateAttendanceRecord = async (attendanceId, updateData) => {
  try {
    const response = await apiClient.put(
      `/attendance/${attendanceId}`,
      updateData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating attendance:", error);
    throw error;
  }
};

// Approve/Reject attendance (Admin only)
export const approveAttendance = async (attendanceId, approvalData) => {
  try {
    const response = await apiClient.put(
      `/attendance/${attendanceId}/approve`,
      approvalData
    );
    return response.data;
  } catch (error) {
    console.error("Error approving attendance:", error);
    throw error;
  }
};

// Delete attendance record (Admin only)
export const deleteAttendanceRecord = async (attendanceId) => {
  try {
    const response = await apiClient.delete(`/attendance/${attendanceId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting attendance:", error);
    throw error;
  }
};

////////////  TASK FLOW SERVICES ⚒️⚒️⚒️⚒️⚒️ ////////////////

// Get all task flows for a company
export const getTaskFlows = async (companyId) => {
  try {
    const response = await apiClient.get(`/companies/${companyId}/task-flows`);
    return response.data;
  } catch (error) {
    console.error("Error fetching task flows:", error);
    throw error;
  }
};

// Create a new task flow
export const createTaskFlow = async (companyId, taskFlowData) => {
  try {
    const response = await apiClient.post(
      `/companies/${companyId}/task-flows`,
      taskFlowData
    );
    return response.data;
  } catch (error) {
    console.error("Error creating task flow:", error);
    throw error;
  }
};

// Update a task flow
export const updateTaskFlow = async (companyId, taskFlowId, taskFlowData) => {
  try {
    const response = await apiClient.put(
      `/companies/${companyId}/task-flows/${taskFlowId}`,
      taskFlowData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating task flow:", error);
    throw error;
  }
};

// Delete a task flow (soft delete)
export const deleteTaskFlow = async (companyId, taskFlowId) => {
  try {
    const response = await apiClient.delete(
      `/companies/${companyId}/task-flows/${taskFlowId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting task flow:", error);
    throw error;
  }
};

// Restore a task flow
export const restoreTaskFlow = async (companyId, taskFlowId) => {
  try {
    const response = await apiClient.patch(
      `/companies/${companyId}/task-flows/${taskFlowId}/restore`
    );
    return response.data;
  } catch (error) {
    console.error("Error restoring task flow:", error);
    throw error;
  }
};

// Who would do each stage of a flow on a project (role -> person from the team)
export const resolveTaskFlow = async (companyId, taskFlowId, payload) => {
  try {
    const response = await apiClient.post(
      `/companies/${companyId}/task-flows/${taskFlowId}/resolve`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error resolving task flow:", error);
    throw error;
  }
};

// Permanently delete a task flow
export const permanentDeleteTaskFlow = async (companyId, taskFlowId) => {
  try {
    const response = await apiClient.delete(
      `/companies/${companyId}/task-flows/${taskFlowId}/hard`
    );
    return response.data;
  } catch (error) {
    console.error("Error permanently deleting task flow:", error);
    throw error;
  }
};


// Company-wide delete operations
export const deleteAllCompanyTasks = async () => {
  try {
    const response = await apiClient.delete("/tasks/company/all");
    return response.data;
  } catch (error) {
    console.error("Error deleting all company tasks:", error);
    throw error;
  }
};

export const getUnscheduledTasks = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    // Add filters to query parameters
    if (filters.page) params.append("page", filters.page);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.search) params.append("search", filters.search);
    if (filters.priority) params.append("priority", filters.priority);
    if (filters.projectId) params.append("projectId", filters.projectId);
    if (filters.assignerId) params.append("assignerId", filters.assignerId);
    if (filters.sortBy) params.append("sortBy", filters.sortBy);
    if (filters.sortOrder) params.append("sortOrder", filters.sortOrder);

    const queryString = params.toString();
    const url = `/tasks/unscheduled${queryString ? `?${queryString}` : ""}`;

    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching unscheduled tasks:", error);
    throw error;
  }
};

export const scheduleSubTask = async (subTaskId, startDate, dueDate) => {
  try {
    const response = await apiClient.put(`/subtasks/${subTaskId}/schedule`, {
      startDate,
      dueDate,
    });
    return response.data;
  } catch (error) {
    console.error("Error scheduling subtask:", error);
    throw error;
  }
};

export const deleteAllCompanyProjects = async () => {
  try {
    const response = await apiClient.delete("/projects/company/all");
    return response.data;
  } catch (error) {
    console.error("Error deleting all company projects:", error);
    throw error;
  }
};

export const deleteAllCompanyEmployees = async () => {
  try {
    const response = await apiClient.delete("/employee/company/all");
    return response.data;
  } catch (error) {
    console.error("Error deleting all company employees:", error);
    throw error;
  }
};

// Project Field API entries
export const getProjectFields = async (companyId) => {
  const response = await apiClient.get(`/companies/${companyId}/project-fields`);
  return response.data;
};

export const createProjectField = async (companyId, fieldData) => {
  const response = await apiClient.post(`/companies/${companyId}/project-fields`, fieldData);
  return response.data;
};

export const updateProjectField = async (companyId, fieldId, fieldData) => {
  const response = await apiClient.put(`/companies/${companyId}/project-fields/${fieldId}`, fieldData);
  return response.data;
};

export const deleteProjectField = async (companyId, fieldId) => {
  const response = await apiClient.delete(`/companies/${companyId}/project-fields/${fieldId}`);
  return response.data;
};

export const reorderProjectFields = async (companyId, fieldIds) => {
  const response = await apiClient.put(`/companies/${companyId}/project-fields/reorder`, { fieldIds });
  return response.data;
};

export const submitSubTaskPendingReason = async (subTaskId, reason) => {
  try {
    const response = await apiClient.post(`/subtasks/${subTaskId}/pending-reason`, { reason });
    return response.data;
  } catch (error) {
    console.error("Error submitting subtask pending reason:", error);
    throw error;
  }
};



export const updateCompanyPortalConfig = async (companyId, portalData) => {
  const response = await apiClient.patch(`/companies/${companyId}/portal-config`, portalData);
  return response.data;
};

export const getCompanyById = async (companyId) => {
  const { data } = await apiClient.get(`/companies/${companyId}`);
  return data;
};

export const getProjectById = async (projectId) => {
  const { data } = await apiClient.get(`/projects/${projectId}`);
  return data;
};


export const updateProjectPortalConfig = async (projectId, data) => {
  const response = await apiClient.patch(`/projects/${projectId}/portal-config`, data);
  return response.data;
};

export const updateProjectLeadFormConfig = async (projectId, leadFormConfigId) => {
  const response = await apiClient.patch(`/projects/${projectId}/lead-form-config`, { leadFormConfigId });
  return response.data;
};

export const portalLogin = async (data) => {
  try {
    const response = await apiClient.post("/auth/portal-login", data);
    if (response?.data?.token) {
      localStorage.setItem("token", response.data.token);
      return { success: true, user: response.data.user };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || error?.message || "Portal login failed",
      user: null,
    };
  }
};

////////////  HOLIDAY SERVICES ⚒️⚒️⚒️⚒️⚒️ ////////////////

export const getHolidays = async (companyId, year) => {
  const params = year ? `?year=${year}` : "";
  const response = await apiClient.get(`/companies/${companyId}/holidays${params}`);
  return response.data;
};

export const createHoliday = async (companyId, holidayData) => {
  const response = await apiClient.post(`/companies/${companyId}/holidays`, holidayData);
  return response.data;
};

export const bulkCreateHolidays = async (companyId, holidays) => {
  const response = await apiClient.post(`/companies/${companyId}/holidays/bulk`, { holidays });
  return response.data;
};

export const updateHoliday = async (companyId, holidayId, holidayData) => {
  const response = await apiClient.put(`/companies/${companyId}/holidays/${holidayId}`, holidayData);
  return response.data;
};

export const deleteHoliday = async (companyId, holidayId) => {
  const response = await apiClient.delete(`/companies/${companyId}/holidays/${holidayId}`);
  return response.data;
};

export const bulkDeleteHolidays = async (companyId, holidayIds) => {
  const response = await apiClient.delete(`/companies/${companyId}/holidays/bulk`, {
    data: { holidayIds },
  });
  return response.data;
};

////////////  WORK SCHEDULE SERVICES ⚒️⚒️⚒️⚒️⚒️ ////////////////

export const getWorkSchedule = async (companyId) => {
  const response = await apiClient.get(`/companies/${companyId}/work-schedule`);
  return response.data;
};

export const saveWorkSchedule = async (companyId, scheduleData) => {
  const response = await apiClient.put(
    `/companies/${companyId}/work-schedule`,
    scheduleData
  );
  return response.data;
};

////////////  LEAVE POLICY SERVICES ⚒️⚒️⚒️⚒️⚒️ ////////////////

export const getLeavePolicy = async (companyId) => {
  const response = await apiClient.get(`/companies/${companyId}/leave-policy`);
  return response.data;
};

export const saveLeavePolicy = async (companyId, policyData) => {
  const response = await apiClient.put(`/companies/${companyId}/leave-policy`, {
    policyData,
  });
  return response.data;
};


// Performance API functions
export const getLeaderboard = async (type = "weekly", periodKey = null) => {
  try {
    const params = new URLSearchParams();
    params.append("type", type);
    if (periodKey) params.append("periodKey", periodKey);

    const response = await apiClient.get(`/performance/leaderboard?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching leaderboard:", error);
    throw error;
  }
};

export const getPerformanceTrend = async (type = "weekly") => {
  try {
    const response = await apiClient.get(`/performance/trend?type=${type}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching performance trend:", error);
    throw error;
  }
};

export const getEmployeePerformance = async (employeeId, type = "monthly", periodKey) => {
  try {
    const query = `type=${type}${periodKey ? `&periodKey=${periodKey}` : ""}`;
    const response = await apiClient.get(`/performance/employee/${employeeId}?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching employee performance:", error);
    throw error;
  }
};

export const getMyPerformance = async (type = "monthly", periodKey) => {
  try {
    const params = new URLSearchParams({ type });
    if (periodKey) params.set("periodKey", periodKey);
    const response = await apiClient.get(`/performance/me?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching my performance:", error);
    throw error;
  }
};

export const resetCompanyPerformance = async ({ dryRun = false } = {}) => {
  try {
    const url = dryRun
      ? "/performance/reset?dryRun=true"
      : "/performance/reset";
    const response = await apiClient.post(url, dryRun ? {} : { confirm: "RESET" });
    return response.data;
  } catch (error) {
    console.error("Error resetting company performance:", error);
    throw error;
  }
};

export const resetEmployeePerformance = async (employeeId) => {
  try {
    const response = await apiClient.post(
      `/performance/reset/employee/${employeeId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error resetting employee performance:", error);
    throw error;
  }
};

export const addBonusPoints = async (bonusData) => {
  try {
    const response = await apiClient.post("/performance/bonus", bonusData);
    return response.data;
  } catch (error) {
    console.error("Error adding bonus points:", error);
    throw error;
  }
};

export const updatePerformanceLedgerEntry = async (employeeId, payload) => {
  const response = await apiClient.patch(
    `/performance/employee/${employeeId}/ledger`,
    payload
  );
  return response.data;
};

export const deletePerformanceLedgerEntry = async (employeeId, payload) => {
  const response = await apiClient.delete(
    `/performance/employee/${employeeId}/ledger`,
    { data: payload }
  );
  return response.data;
};

export const getNudges = async () => {
  try {
    const response = await apiClient.get("/performance/nudges");
    return response.data;
  } catch (error) {
    console.error("Error fetching nudges:", error);
    throw error;
  }
};

export const updateCompany = async (companyId, updatedData) => {
  const { data } = await apiClient.patch(`/companies/${companyId}`, updatedData);
  return data;
};

export const updateProjectSocialConfig = async (projectId, config) => {
  const response = await apiClient.patch(`/projects/${projectId}/social-config`, config);
  return response.data;
};

// Task Category APIs
export const getTaskCategories = async (companyId) => {
  const response = await apiClient.get(`/companies/${companyId}/task-categories`);
  return response.data.data;
};

export const createTaskCategory = async (companyId, data) => {
  const response = await apiClient.post(`/companies/${companyId}/task-categories`, data);
  return response.data;
};

export const updateTaskCategory = async (companyId, categoryId, data) => {
  const response = await apiClient.put(`/companies/${companyId}/task-categories/${categoryId}`, data);
  return response.data;
};

export const deleteTaskCategory = async (companyId, categoryId) => {
  const response = await apiClient.delete(`/companies/${companyId}/task-categories/${categoryId}`);
  return response.data;
};

// Department APIs
export const getDepartments = async (companyId) => {
  const response = await apiClient.get(`/companies/${companyId}/departments`);
  return response.data.data;
};

export const createDepartment = async (companyId, data) => {
  const response = await apiClient.post(`/companies/${companyId}/departments`, data);
  return response.data;
};

export const updateDepartment = async (companyId, departmentId, data) => {
  const response = await apiClient.put(`/companies/${companyId}/departments/${departmentId}`, data);
  return response.data;
};

export const deleteDepartment = async (companyId, departmentId) => {
  const response = await apiClient.delete(`/companies/${companyId}/departments/${departmentId}`);
  return response.data;
};

export const getMeetings = async () => {
  const response = await apiClient.get("/meetings");
  return response.data;
};

export const getUpcomingMeetingCount = async () => {
  const response = await apiClient.get("/meetings/upcoming-count");
  return response.data;
};

export const createMeeting = async (data) => {
  const response = await apiClient.post("/meetings", data);
  return response.data;
};

export const updateMeeting = async (meetingId, data) => {
  const response = await apiClient.put(`/meetings/${meetingId}`, data);
  return response.data;
};

export const cancelMeeting = async (meetingId) => {
  const response = await apiClient.post(`/meetings/${meetingId}/cancel`);
  return response.data;
};

export const reportMeetingAttendance = async (meetingId, attendees) => {
  const response = await apiClient.post(`/meetings/${meetingId}/attendance`, {
    attendees,
  });
  return response.data;
};

export const addMeetingActionItem = async (meetingId, data) => {
  const response = await apiClient.post(`/meetings/${meetingId}/items`, data);
  return response.data;
};

export const updateMeetingActionItem = async (meetingId, itemId, data) => {
  const response = await apiClient.patch(`/meetings/${meetingId}/items/${itemId}`, data);
  return response.data;
};

export const deleteMeetingActionItem = async (meetingId, itemId) => {
  const response = await apiClient.delete(`/meetings/${meetingId}/items/${itemId}`);
  return response.data;
};

export const generateMeetingMeetLink = async (meetingId) => {
  const response = await apiClient.post(`/meetings/${meetingId}/meet-link`);
  return response.data;
};

export const getGoogleMeetStatus = async () => {
  const response = await apiClient.get("/meetings/google/status");
  return response.data;
};

export const getGoogleMeetConnectUrl = async (returnTo = "/meetings") => {
  const response = await apiClient.get("/meetings/google/connect", {
    params: { returnTo },
  });
  return response.data;
};

export const disconnectGoogleMeet = async () => {
  const response = await apiClient.post("/meetings/google/disconnect");
  return response.data;
};

export const getDepartmentDashboard = async (companyId) => {
  const response = await apiClient.get(`/companies/${companyId}/departments/dashboard`);
  return response.data.data;
};

export const getDepartmentHeadStatus = async (companyId) => {
  const response = await apiClient.get(
    `/companies/${companyId}/departments/head-status`
  );
  return response.data.data;
};

export const getDailyChecklistSummary = async (date) => {
  const response = await apiClient.get("/projects/daily-checklist/summary", {
    params: { date },
  });
  return response.data;
};

// ── Client asset bank (banked footage / deliverables) ───────────────────────
export const getAssetBank = async (projectId, params = {}) => {
  const response = await apiClient.get(`/projects/${projectId}/asset-bank`, { params });
  return response.data;
};

export const addAssetBankItems = async (projectId, data) => {
  const response = await apiClient.post(`/projects/${projectId}/asset-bank`, data);
  return response.data;
};

export const updateAssetBankItem = async (projectId, itemId, data) => {
  const response = await apiClient.patch(`/projects/${projectId}/asset-bank/${itemId}`, data);
  return response.data;
};

export const removeAssetBankItem = async (projectId, itemId) => {
  const response = await apiClient.delete(`/projects/${projectId}/asset-bank/${itemId}`);
  return response.data;
};

export const releaseAssetBankItem = async (projectId, itemId) => {
  const response = await apiClient.post(`/projects/${projectId}/asset-bank/${itemId}/release`);
  return response.data;
};

// ── Shoot sessions (a task that covers other scheduled tasks) ───────────────
export const getShootCandidates = async (projectId, params = {}) => {
  const response = await apiClient.get(`/projects/${projectId}/shoot-candidates`, { params });
  return response.data;
};
